import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';
import Cell from './cell';
import SortCaret from './sort-caret';
import { ColumnProps, alignment, getColumnWidth } from './column';
import { isSortable } from './table-utils';
import cx from 'classnames';
import TableSearch from './table-search';
import { Checkbox } from '../../atoms/inputs/index';
import { ToolTip } from '../tool-tip';

export interface Props {
  className?: string;
  column: ColumnProps;
  // sorting props
  sortKey?: string;
  sortAscending: boolean;
  onSort?: (string) => void;
  // search props
  onSearch?: (string) => void;
  // only checkbox cell will get these props
  onCheckChange?: () => void;
  checked?: boolean;
  value?: string;
}

class HeaderCell extends React.Component<Props> {
  renderCheckbox = () => {
    const { onCheckChange, checked } = this.props;
    return (
      onCheckChange && <Checkbox onChange={onCheckChange} checked={checked} />
    );
  };
  public render() {
    const {
      className,
      sortKey,
      sortAscending,
      onSort,
      column,
      onSearch,
      value,
    } = this.props;

    const cellWidth =
      getColumnWidth(column) < 200 ? 200 : getColumnWidth(column);

    const active = sortKey === column.dataKey;
    const { sticky, labelTooltip } = column;

    return (
      <td
        onClick={
          isSortable(column) ? onSort.bind(null, column.dataKey) : undefined
        }
        className={cx(`${className} header-cell`, {
          sticky,
          active,
        })}
      >
        <div className="content">
          {this.renderCheckbox()}
          {onSearch && (
            <TableSearch
              onChange={onSearch}
              value={value}
              cellWidth={cellWidth}
            />
          )}
          {!!labelTooltip ? (
            <ToolTip tooltip={labelTooltip}>{column.label}</ToolTip>
          ) : (
            column.label
          )}
          {isSortable(column) && (
            <SortCaret sortAscending={sortAscending} active={active} />
          )}
        </div>
      </td>
    );
  }
}

export default styled(HeaderCell)`
  position: sticky;
  top: 0;
  background: ${colors.grey10o};
  z-index: 3;
  color: ${colors.grey500};
  min-width: ${({ column }) => getColumnWidth(column)}px;
  max-width: ${({ column }) => column.maxWidth}px;
  &.sticky {
    width: 1px;
    max-width: ${({ column }) => getColumnWidth(column)}px;
    /* ensure the searchable cell is always above other header cells */
    z-index: ${({ onSearch }) => (onSearch ? 5 : 4)};
  }
  .content {
    height: 60px;
    display: flex;
    justify-content: ${alignment};
    align-items: center;
    text-align: ${alignment};
    position: relative;
    border-bottom: 1px solid ${colors.grey100};
    width: 100%;
    max-width: 100%;
    padding-left: ${({ column }) =>
      isSortable(column) && (!column.align || column.align === 'center')
        ? '1rem'
        : '0'};
  }
  user-select: none;
  &.active {
    color: ${colors.black};
  }
  cursor: ${(props: Props) =>
    isSortable(props.column) ? 'pointer' : 'default'};
`;
